import { createSelector } from '@ngrx/store';
import { getCustomHubState } from '../feature.selector';
import { CustomHubState } from '../state';

export const getCustomHubConfigContent = createSelector(
  getCustomHubState,
  (state: CustomHubState) => state && state.hubState
);

export const getCustomHubPageConfig = createSelector(
  getCustomHubConfigContent,
  state => state && state.hub
);

export const getConfigCategories = createSelector(
  getCustomHubPageConfig,
  state => state && state.categories
);

export const getCustomSeoContent = createSelector(
  getCustomHubPageConfig, 
  state => state && state.seoContent
);
